export function cameraUpdate(map, action, amount = 0) {
  if (!map) return;
  const heading = map.getHeading?.() || 0;
  const tilt = map.getTilt?.() || 0;
  const zoom = map.getZoom?.() ?? 17;
  if (action === 'rotate') map.moveCamera({ heading: (heading + amount + 360) % 360 });
  if (action === 'tilt') {
    const next = Math.max(0, Math.min(67.5, tilt + amount));
    map.moveCamera({ tilt: next, zoom: next > 0 ? Math.max(18, zoom) : zoom });
  }
  if (action === 'reset') map.moveCamera({ heading: 0, tilt: 0 });
  if (action === 'zoom') map.setZoom(Math.max(1, Math.min(22, zoom + amount)));
}
